/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowexample22Inputs */

const en_aiflowexample22 = /** @type {(inputs: Aiflowexample22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazz breakfast on Sunday from 10 am, 24 euros with buffet`)
};

const de_aiflowexample22 = /** @type {(inputs: Aiflowexample22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazzfrühstück am Sonntag ab 10 Uhr, 24 Euro mit Buffet`)
};

/**
* | output |
* | --- |
* | "Jazz breakfast on Sunday from 10 am, 24 euros with buffet" |
*
* @param {Aiflowexample22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowexample22 = /** @type {((inputs?: Aiflowexample22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowexample22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowexample22(inputs)
	return de_aiflowexample22(inputs)
});
export { aiflowexample22 as "aiFlowExample2" }